import { DEVTOOLS_ICONS, DevtoolsIconDef } from "./StringDevtoolsIcons";

export type DevtoolsIconSize = 12 | 16 | 20;

export class StringDevIconRegistry {
  private static instance: StringDevIconRegistry | null = null;
  private spriteRoot: SVGSVGElement | null = null;

  private constructor() {
    for (const icon of DEVTOOLS_ICONS) {
      this.register(icon);
    }
  }

  public static getInstance(): StringDevIconRegistry {
    if (!this.instance) {
      this.instance = new StringDevIconRegistry();
    }
    return this.instance;
  }

  public register(icon: DevtoolsIconDef): void {
    const sprite = this.ensureSprite();

    if (sprite.querySelector(`#${icon.id}`)) {
      return;
    }

    const symbol = document.createElementNS("http://www.w3.org/2000/svg", "symbol");
    symbol.id = icon.id;
    symbol.setAttribute("viewBox", icon.viewBox);
    symbol.innerHTML = icon.content;
    sprite.appendChild(symbol);
  }

  public resolve(size: DevtoolsIconSize, name: string, ...modifiers: string[]): string {
    const id = `icon-${size}_${name}`;
    const extraAttrs = modifiers.map((m) => ` data-stdg-icon-${m}`).join("");
    return `<svg data-stdg-icon-${size}${extraAttrs}><use href="#${id}"></use></svg>`;
  }

  private ensureSprite(): SVGSVGElement {
    if (this.spriteRoot) {
      return this.spriteRoot;
    }

    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("data-string-devtools-icon-sprite", "");
    svg.setAttribute("aria-hidden", "true");
    svg.style.cssText = "display:none;position:absolute;width:0;height:0;overflow:hidden";
    (document.body ?? document.documentElement).prepend(svg);
    this.spriteRoot = svg;
    return svg;
  }
}

export function resolveDevtoolsIcon(
  size: DevtoolsIconSize,
  name: string,
  ...modifiers: string[]
): string {
  return StringDevIconRegistry.getInstance().resolve(size, name, ...modifiers);
}
